// extracted by mini-css-extract-plugin
export var leftAlign = "_d-2";
export var popper = "_d-0";
export var subtitle = "_d-1";